import {
    getAudienceReachPrediction,
    getProfRolesPrediction,
    getVacancyProfRole,
} from 'components/CpcFlexibleCreate/PredictWindow/utils/api';

import {
    setAudienceData,
    setIsPredictWindowReady,
    setPredictedProfRoles,
    setVacancyProfRole,
} from 'store/models/predictWindow';
import { AppThunkAction } from 'store/utils';

export const computeVacancyProfRoleAndReachPrediction =
    (...props: Parameters<typeof getVacancyProfRole>): AppThunkAction =>
    (dispatch) =>
        getVacancyProfRole(...props)
            .then((data) => {
                dispatch(setVacancyProfRole(data.vacancyProfRoleId));

                return getProfRolesPrediction(data);
            })
            .then((vacancyProfRole) => {
                dispatch(setPredictedProfRoles(vacancyProfRole));
            })
            .catch(() => {
                dispatch(setIsPredictWindowReady(false));
            });

export const computeAudienceReachPrediction =
    (...props: Parameters<typeof getAudienceReachPrediction>): AppThunkAction =>
    (dispatch) =>
        getAudienceReachPrediction(...props)
            .then((audienceData) => {
                dispatch(setAudienceData(audienceData));
            })
            .catch(() => {
                dispatch(setIsPredictWindowReady(false));
            });
